<div class="pcn-full-section" [ngClass]="{
    focus: !interactPcn,
    opened: this.global.isPcnPanelLocked,
    closed: !this.global.isPcnPanelLocked,
    disabled: disablePcnBlock
  }">

  <!--pcn lock status-->
  <form id="PcnForm" #pcnForm="ngForm" (submit)="submitPcn($event)">
    <div class="pcn-block">
      <div class="pcn-lock-block" *ngIf="global.isPcnDetailsLocked">
        <img class="lock" [src]="constants.assetsPath + '/img/icons/lock-purple-mid.svg'" />
      </div>
      <div class="pcn-lock-icon">
        <a [routerLink]="['/pcn-details']" role="button">
          <img alt="barbour logic logo" class="logo" [src]="constants.assetsPath + '/img/icons/logo.svg'"
            id="imgBlLogo" />
        </a>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="27" height="27"
          viewBox="0 0 27 27" (click)="togglePcnPanelLocked()" [ngClass]="{
            opened: this.global.isPcnPanelLocked,
            closed: !this.global.isPcnPanelLocked,
            hidden: !this.global.isPcnPinVisible
          }">
          <image id="icons8-push-pin-100" width="27" height="27"
            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFEElEQVR4nO2dXYhWRRiAJyvdrCCjIrIyiIrKrKwQkugiKLrIotJ0+1nrwkiwIImkQuqiiMIugqIiIgLprqW2H8KbjLAQkqgozH4wIjBTk8xEd3tidudbPseZ852z3zlnZs55H9iLhfPNN2eefec983dWKUEQBEEQBEEQUgM4NnQdBDUuYjbwJTAKrAdmSMMEBFjH4YwA00VKOCHPciTD0oWFE3IK8L1Dio6UgVD1ajXA6cAPDikfiZQwQi4AduPmY+C4EPVqJcDJnuiQSAkg4yjgXYeAQyIlAMAqR8NvAy7yJHrJKRXKOAf4x2rwv4GLuxK9SKkL4D1HBNxnXXMa8K0k+upl3OJo5GHPtRIpFcuYCfxiydBd15yMz0ikVCjkcUd0PJbjcyKlAhnHA39YMn7KOxoXKeULedQRHYsKliE5pcTo2GHJ2KIHh1MoS7qvEoSsdETHrX2UJ5HSp5Atlgw96JvWZ5kSKVNsuAWO6BgqqWyJlCk02uuWjD/LXDuXSCnWWDOAvZaQdWXJECnFG+pmR3c1PoEoUgIAvGXJ2FTx90lO8aF3jgB7LCGrVMWIFA/AQkvGf8BZqgYk0TsAnrSEfKZqRKRYABstIY+ompHuywAcDeyzhFyiAiCRosYbYZ4l4/epTCSKlPL+Kh+2hKyPoE7teiQGpgE3ARscN/2AioBWdF/AicBDwM/4uVBFQmMjRY8pgOccgz+bl1RkNEoKcJmZEjmYIWHMHClYqCIl6e7L5IdFwCc9omE/8ApwnkqAjEgZiebcI7AE+BR4FThDJ2Rgaw8RO4GngFNVYgBzPRu8h4MfrzMCDlldTxY/mvXymSpBgKuBXzPu7/2gB1GBS8nH58Bt/a6LBz4KsbpHHuzwZuiK6v7TxZg5z3GNShhgDvCB5x53mSMR3ewLXeEB8/hnox9v56tEAaYDaxzHIDp8DZzrSPQbQtc9S8quFKUA1wPf4ecN4ISu608C1gJPALNUDDRBCnCDXofJEKH3Gi9WqZCiFOAYcwbliwwR+knyRR0JKtG+d8STU65SkQCcaTZ0bycbPbidp1Im1khhIgmvNgPZXmOmzTpyVFOIQQowy0zhvAB8Qz70csB1qonULQVYDDxvusxtOaKgg94t+RpwhWo6dUkBhijGmNlYMZTqVE60iZ6JGQPXLKzNv6ZL0gtks1WbqTJSmMgTLg6YccUzwI36ZFZ5d9QAqpLCkXu6PtTbiKJZo2hT9wVc6ShrQTW1byiUKAV42ypjY3U1bxjA7fqnrO4LONuxelfo6HTbZRw0r3gdLCNSHG8p3ZrqIlgoGR36lmL2d/1lfWZFrTeWsAy7WxkFlnVdU1iKmZPqZkf023EiljHouDa3FDNlbs/Srq315lLDzCvlklFUio4ux/6u5LYURS2jiBTHYtLLkwUIhwMsdcjQvy/J21ZkPxI/6JgkPF88FIuMO4s2GP5IsXlHZPi3lJYio6CUaDdoN0pGTimbJy8UJhts0DS+LWNpWW2EP6d8Fc0+qMhlLKvguwY8UpyvjG0dujuqS0YPKb+ptpMhY7CG7x4wC1AdnlZtBrgrlAzrRQN62+e1qs0Ad3iepu4OXbfW4RmBi4wQiIw0ZNwTum5tleFK4CKjbkRGRJgFoFHHNLdERt0Ayx27xsfKeru0UADgXpERCSIjIoDLPZGxPHTdWov1H230O3PvD12n1mOkiIzYXjgWug6CIAiCIAiCIAiCKpX/AdbqyrojGE47AAAAAElFTkSuQmCC" />
        </svg>
      </div>
      <div class="pcn-block-title">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 37 38">
          <g id="Group_212" data-name="Group 210" transform="translate(-246 -132)">
            <circle id="Ellipse_9" data-name="Ellipse 8" cx="18.5" cy="18.5" r="18.5" transform="translate(246 132)"
              fill="#f9d83f" />
            <text id="_3" data-name="1" transform="translate(258 162)" fill="#491c4c" font-size="30"
              font-family="Outfit" font-weight="700">
              <tspan x="0" y="0">1</tspan>
            </text>
          </g>
        </svg>
        <div class="title-text">start letter</div>
      </div>
      <!-- </div> -->

      <!-- PCN Number -->
      <label class="form-group">
        <span class="pcn-block-input-header">PCN number <a class="reset-link" id="btnResetPcn"
            (click)="resetPcn()">reset</a></span>
        <div class="pcn-block-input pcn-block-textbox input-with-button">
          <kendo-label class="k-form" text="PCN number">
            <div 
            class="input-button-wrapper"
            [ngClass]="{ disabled: pcnLocked }">
            
            <kendo-textbox 
              id="txtPcn"
              [ngClass]="{ error: pcnPrefixError }"
              class="inputTextBox"
              name="pcn"
              [(value)]="pcnDetails.pcn"
              (change)="onChangePcnNumber()"
              type="text"
              [disabled]="pcnLocked"
              (focus)="tPcn.close()"
              triggers="manual"
              placement="bottom"
              [ngbTooltip]="pcnPrefixError"
              aria-label="test"
              #tPcn="ngbTooltip"
              [placeholder]="isAdminAccount ? pcnPrefix : ''">
            </kendo-textbox>
          
            <!-- Generate Button (Shown only for Admins) -->
            <button 
              *ngIf="isAdminAccount" 
              type="button" 
              class="generate-button" 
              id="btnGeneratePcn"
              [disabled]="pcnLocked"
              (click)="generatePCN()">
              Generate
            </button>
          </div>
          </kendo-label>
        </div>
        <ng-template #pcnPrefixError>
          {{ getPcnNumberError() }}
          <div [innerHTML]="serverPcnErrorMessage"></div>
        </ng-template>
      </label>

      <!-- Contravention -->
      <label class="form-group">
        <span class="pcn-block-input-header">contravention</span>
        <span class="pcn-block-input">
          <kendo-label class="k-form" text="contravention">
            <kendo-textbox #contraventionField 
              id="txtContravention" 
              name="contravention" 
              class="pcn-block-textbox"
              [ngClass]="{ disabled: !isContraventionEnabled }" 
              [disabled]="!isContraventionEnabled"
              [(value)]="tempContravention" 
              (valueChange)="contraventionInput$.next($event)"
              type="text" 
              [selectOnFocus]="true" 
              (focus)="tContravention.close()" 
              triggers="manual" 
              placement="bottom"
              [ngbTooltip]="contraventionError" 
              #tContravention="ngbTooltip" required>
            </kendo-textbox>
          </kendo-label>
        </span>
        <ng-template #contraventionError>
          {{ getContraventionError() }}
          <div [innerHTML]="contraventionErrorMessage"></div>
        </ng-template>
      </label>

      <!-- Action -->
      <label class="form-group">
        <span class="pcn-block-input-header">action</span>
        <span class="pcn-block-input">
          <kendo-label class="k-form" text="action">
            <kendo-dropdownlist [ngClass]="{
                disabled: !pcnNumberValidation || !isContraventionValid,
                'pcn-block-input': true,
                'icon-dropdown': true,
                error: pcnPrefixError
              }" 
              id="ddlAction" 
              name="action" 
              [disabled]="!pcnNumberValidation || !isContraventionValid"
              [(value)]="tempActionId" 
              (valueChange)="onChangeAction($event)"
              [data]="this.pcnDetails.actions" 
              textField="description" 
              valueField="id" 
              [valuePrimitive]="true"
              fillMode="solid" 
              size="large" 
              [popupSettings]="{
                popupClass: 'dropdown'
              }">
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <div class="dd-template">{{ dataItem.description }}</div>
              </ng-template>
            </kendo-dropdownlist>
          </kendo-label>
        </span>
      </label>

      <!-- PCN Type -->
      <label class="form-group">
        <span class="pcn-block-input-header">PCN type</span>
        <span class="pcn-block-input">
          <kendo-label class="k-form" text="PCN type">
            <kendo-dropdownlist [ngClass]="{
                disabled: !pcnNumberValidation || !isContraventionValid || !isActionPcn,
                'pcn-block-input': true
              }" 
              id="ddlSource" 
              name="source"
              [disabled]="!pcnNumberValidation || !isContraventionValid || !isActionPcn"
              (valueChange)="onChangeSource($event)" 
              [(value)]="tempSourceId"
              [data]="this.pcnDetails.sources" 
              textField="description" 
              valueField="id" 
              [valuePrimitive]="true">
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <div class="dd-template">{{ dataItem.description }}</div>
              </ng-template>
            </kendo-dropdownlist>
          </kendo-label>
        </span>
      </label>

      <!-- Stage -->
      <label class="form-group">
        <span class="pcn-block-input-header">stage</span>
        <span class="pcn-block-input">
          <kendo-label class="k-form" text="stage">
            <kendo-dropdownlist [ngClass]="{
                disabled: !pcnNumberValidation || !isContraventionValid || !isActionPcn,
                'pcn-block-input': true
              }" 
              id="ddlStage" 
              name="stage" 
              [disabled]="!pcnNumberValidation || !isContraventionValid || !isActionPcn"
              (valueChange)="onChangeStage($event)" 
              [(value)]="tempStageId"
              [data]="this.pcnDetails.stages" 
              textField="display" 
              valueField="id" 
              [valuePrimitive]="true"
              rounded="medium">
              <ng-template kendoDropDownListItemTemplate let-dataItem>
                <div class="dd-template">{{ dataItem.display }}</div>
              </ng-template>
            </kendo-dropdownlist>
          </kendo-label>
        </span>
      </label>

      <div class="two-block-section">
        <!-- Current Charge -->
        <label class="form-group">
          <span class="pcn-block-input-header">current charge</span>
          <span class="current-charge-multi" [ngClass]="{
              disabled:
                !isChargeNowEnabled || !pcnNumberValidation || !isContraventionValid || !isActionPcn
            }">

            <kendo-label class="k-form" text="fine amount">
              <kendo-multicolumncombobox [ngClass]="{
                  disabled: !pcnNumberValidation || !isContraventionValid || !isActionPcn,
                  'pcn-block-input': true
                }" 
                id="fineAmountId" 
                [data]="this.pcnDetails.fineAmounts" 
                textField="chargeAmountString"
                [style.width.px]="126" 
                valueField="id" 
                [valuePrimitive]="true" 
                [(value)]="tempChargeId"
                [disabled]="!pcnNumberValidation || !isContraventionValid" 
                (valueChange)="onFineNowChange()">
                
                <kendo-combobox-column field="totalAmount" title="Charge" [width]="75">
                  <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                    <div class="dd-template">
                      {{ dataItem.totalAmount | currency: 'GBP' : 'symbol-narrow' : '1.0-0' }}
                    </div>
                  </ng-template>
                </kendo-combobox-column>
                <kendo-combobox-column field="chargeTypeString" title="Type" [width]="300"></kendo-combobox-column>
                <kendo-combobox-column field="feesString" title="Fees" [width]="300"></kendo-combobox-column>
              </kendo-multicolumncombobox>
            </kendo-label>
          </span>
        </label>
        <!-- Paid Amount -->
        <label class="form-group">
          <span class="paid-amount-label">paid amount</span>
          <span class="paid-amount-numerictextbox">
            <kendo-label class="k-form" text="paid amount">
              <kendo-numerictextbox 
                id="txtPaidAmount" 
                name="paidAmount"             
                [ngClass]="{
                  disabled: !pcnNumberValidation || !isContraventionValid || !isActionPcn,
                  'pcn-block-input': true
                }" 
                [disabled]="!pcnNumberValidation || !isContraventionValid || !isActionPcn" 
                [style.width.px]="126"
                [format]="currencyFormatOptions" 
                [min]="0" 
                [(value)]="paidAmountValue"
                (valueChange)="onFineNowChange()">

              </kendo-numerictextbox>
            </kendo-label>
          </span>
        </label>
      </div>

      <span class="submit-layer">
          <span class="pending-changes-hint" *ngIf="hasPendingChanges">
            press update to apply changes
          </span>
        <input aria-label="" type="submit" class="app-submit"  [ngClass]="{ 'pending-update': hasPendingChanges }" [value]="submitButtonValue" id="btnContinue" 
        [disabled]="
            !formChanged ||
            savingStatus ||
            !pcnNumberValidation ||
            !isContraventionValid ||
            tempContravention === '' ||
            !isFineNowValid() ||
            waitingFineAmount ||
            isActionChanging
          " />
      </span>

      <a class="extra-fields-link" id="btnExtraFields" *ngIf="pcnNumberValidation && isContraventionValid"
        (click)="this.global.showPcnExtraFields = !this.global.showPcnExtraFields">view additional details</a>

      <div class="council-logo">
        <img [src]="councilLogo" alt="Council Logo" class="logo-image" />
      </div>

      <div class="open-arrow" [ngClass]="{ hide: this.global.isPcnPanelLocked }" id="btnExtraPcnDetailsArrow"
        *ngIf="pcnNumberValidation && isContraventionValid"></div>
    </div>
    <div class="pcn-extra-fields" [ngClass]="{ opened: this.global.showPcnExtraFields }">
      <div class="close-icon small white" (click)="this.global.showPcnExtraFields = false"></div>

      <div class="extra-fields">
        <div class="col">
          <div class="title-text">personal details</div>
          <label class="form-group">
            <span>title</span>
            <kendo-label class="k-form" text="title">
              <kendo-textbox class="pcn-block-input" id="ddlTitle" name="title" [(value)]="pcnDetails.title">
              </kendo-textbox>
            </kendo-label>
          </label>
          <label class="form-group">
            <span>first name</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="first name">
                <kendo-textbox type="text" [(value)]="pcnDetails.name" id="txtFirstName" name="name"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>last name</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="last name">
                <kendo-textbox type="text" [(value)]="pcnDetails.lastName" id="txtLastName" name="lastName"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>postcode</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="postcode">
                <kendo-textbox type="text" [(value)]="pcnDetails.postcode" id="txtPostcode" name="postcode"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>email</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="email">
                <kendo-textbox type="text" [(value)]="pcnDetails.email" id="txtEmail" name="email"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>address</span>
            <span class="input-layer address">
              <kendo-label class="k-form" text="address line 1">
                <kendo-textbox type="text" [(value)]="pcnDetails.address1" id="txtAddress1" name="address1"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
            <span class="input-layer address">
              <kendo-label class="k-form" text="address line 2">
                <kendo-textbox type="text" [(value)]="pcnDetails.address2" id="txtAddress2" name="address2"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
            <span class="input-layer address">
              <kendo-label class="k-form" text="address line 3">
                <kendo-textbox type="text" [(value)]="pcnDetails.address3" id="txtAddress3" name="address3"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
            <span class="input-layer address">
              <kendo-label class="k-form" text="address line 4">
                <kendo-textbox type="text" [(value)]="pcnDetails.address4" id="txtAddress4" name="address4"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
            <span class="input-layer address">
              <kendo-label class="k-form" text="address line 5">
                <kendo-textbox type="text" [(value)]="pcnDetails.address5" id="txtAddress5" name="address5"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
        </div>

        <div class="col">
          <div class="title-text">case details</div>
          <label class="form-group">
            <span>date</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="date">
                <kendo-datetimepicker class="pcn-block-datepicker" [(value)]="dateIssued" id="dtpDateIssued"
                  name="dateIssued" format="dd/MM/yyyy HH:mm"></kendo-datetimepicker>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>registration</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="registration">
                <kendo-textbox type="text" [(value)]="pcnDetails.registration" id="txtRegistration" name="registration"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>company</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="company">
                <kendo-textbox type="text" [(value)]="pcnDetails.company" id="txtCompany" name="company"
                  class="pcn-block-textbox">
                </kendo-textbox>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>letter arrived</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="letter arrived">
                <kendo-datepicker class="pcn-block-datepicker" [(value)]="letterDate" format="dd/MM/yyyy HH:mm"
                  id="dtpLetterArrived" name="letterdate"></kendo-datepicker>
              </kendo-label>
            </span>
          </label>
          <label class="form-group">
            <span>place</span>
            <span class="input-layer">
              <kendo-label class="k-form" text="place">
                <kendo-textarea [(value)]="pcnDetails.location" id="txtPlace" name="place"
                  class="pcn-block-textbox"></kendo-textarea>
              </kendo-label>
            </span>
          </label>
        </div>
      </div>
    </div>
  </form>

  <!-- <kendo-dialog *ngIf="fineNowChangedMessage === true" (close)="onClickNo()">
    <kendo-dialog-titlebar>
      <div style="font-size: 18px; line-height: 1.3em">
        <span class="k-icon k-i-warning k-icon-md"></span> Alert: Charge now has been changed
      </div>
    </kendo-dialog-titlebar>
    <p style="margin: 30px; text-align: left">
      The value passed in by your NPS system is not a valid RM amount.<br />
      This may be because the PCN has been discounted, cancelled or paid.<br />
      Please ensure you select an appropriate charge amount from the list on the left.<br />
      If you need to reoffer the discount, please select a reason like ‘discount requested – other’.
    </p>
    <kendo-dialog-actions [layout]="actionsLayout">
      <button kendoButton (click)="onClickNo()">OK</button>
    </kendo-dialog-actions>
  </kendo-dialog> -->
</div>
